import { render, staticRenderFns } from "./NewPurchaser.vue?vue&type=template&id=59b2f658&scoped=true&"
import script from "./NewPurchaser.vue?vue&type=script&lang=js&"
export * from "./NewPurchaser.vue?vue&type=script&lang=js&"
import style0 from "./NewPurchaser.vue?vue&type=style&index=0&id=59b2f658&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b2f658",
  null
  
)

export default component.exports